import React from "react"
import { useHistory } from 'react-router-dom'


export default function ListItem({ training }) {
  // REACT ROUTER DOM
  const history = useHistory()


  const goToSelectedTraining = () => {
    history.push(`/trainings/${training.id}`)
  }

  const trainingClassName = () => {
    if (training.is_assigned.includes("Completed")) {
      return "qms-training-table-item color-coded completed"
    } else if (training.is_assigned.includes("Past due")) {
      return "qms-training-table-item color-coded past-due"
    } else if (training.is_assigned.includes("Not Assigned")) {
        return "qms-training-table-item color-coded"
    } else return "qms-training-table-item color-coded to-do"
  }

  return (
    <React.Fragment>
      <tr onClick={ goToSelectedTraining } className={trainingClassName()}>
        <td> 
          <div><strong>{training.type}</strong></div>
        </td>
        <td>
          <div><strong>{training.number}</strong></div>
        </td>
        <td>
          <div>{training.title}</div>
        </td>
        <td>
          <div>{ training.is_assigned }</div>
        </td>
      </tr>
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTraining/Trainings/ListItem.js